import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HomeSingleBlog = ({ title, id, image }) => {
   const truncateText = (text, maxLength) => {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return `${text.substring(0, maxLength)}...`;
   };

   const cardTitle = truncateText(title, 80);

   return (
      <div className="tw-w-full tw-px-3 md:tw-w-1/2 tw-mb-6 md:tw-mb-0">
         <div className="home-news__card">
            <div className="home-news__card-media">
               {/* <span className="home-news__card-blob" aria-hidden="true"></span> */}
               <div
                  className="home-news__card-image"
                  style={image ? { backgroundImage: `url(${image})` } : undefined}
                  aria-hidden="true"
               ></div>
            </div>
            <div className="home-news__card-body">
               <span className="home-news__card-tag">Insight</span>
               <h3 className="home-news__card-title">
                  <Link to={`/BlogDetails/${id}`}>{cardTitle}</Link>
               </h3>
               <Link to={`/BlogDetails/${id}`} className="home-news__card-arrow" aria-label={`Read more: ${cardTitle}`}>
                  <ArrowUpRight size={18} />
               </Link>
            </div>
         </div>
      </div>
   );
};

export default HomeSingleBlog;
